export { default } from './SectionWrapper.styles';
